import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import seekerRoutes from './seekerRoutes';
import providerRoutes from './providerRoutes';
import sharedRoutes from './sharedRoutes';
import segmentPageviews from './guards/segmentPageviews';
import siftPageviews from './guards/siftPageviews';
import { accountBootstrapBeforeEach } from './guards/accountBootstrapGuard';
import { sitterOnboardingBeforeEach } from './guards/sitterOnboardingGuards';
import { emailVerificationOnboardingBeforeEach, trapIfEmailVerificationPending } from './guards/emailVerificationGuard';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [...seekerRoutes, ...providerRoutes, ...sharedRoutes] as RouteRecordRaw[],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Scroll to saved position
    }
    return { top: 0, left: 0 }; // Scroll to the top
  },
});

// WARNING
// If you add beforeEach or afterEach guards, the code will be executed on every page
// You may want to use beforeEnter instead.
// Be careful and write tests~~~

// Load account before route guards that depend on store account (e.g. sitter onboarding redirects)
router.beforeEach(accountBootstrapBeforeEach);

// Variant A onboarding email verification (SC-Web signup + legacy onboarding paths via router)
router.beforeEach(emailVerificationOnboardingBeforeEach);

// Restore server-side headers when leaving onboarding routes (only for provider route navigation)
router.beforeEach(sitterOnboardingBeforeEach);

// Sticky hard-trap: once sent to /verify-email, stay until verified
router.beforeEach(trapIfEmailVerificationPending);

router.afterEach(siftPageviews);
router.afterEach(segmentPageviews);

export default router;
